<div  [formGroup]='parent' >


  <div class="form-field" role="postcode"  [attr.aria-describedBy]="(parent.get(controlName).touched && parent.get(controlName).hasError('required')) ? controlName +'-error' : 'lbl-postcode'">
      <label class="form-label" id="lbl-postcode" [attr.for]="controlName">{{postCodeConfig['labelText']}}</label>
      <div class="form-field-text">
      
      <input type="text" [id]="controlName" [name]="controlName" 
      class="form-control textbox-border"
      [formControlName]="controlName" maxlength="8"
      aria-required="true"
      [attr.aria-invalid] = "(parent.get(controlName).touched && parent.get(controlName).hasError('required')) ? true: false"
      
      [value]="textValue"
      [(ngModel)]="textValue"
      (keyup)="postCodeReformat($event.target.value)"
      (keyup.enter)="validateInput()"
      (blur)="validateInput()"
      placeholder="Please enter"
      [required]="required"
      [attr.aria-controls]="controlName + '-error-div'"
      
    > 
  </div>
  <div [id]="controlName +'-error-div'"  class="form-validation-error"
              *ngIf="parent.get(controlName).touched
                      &&
                  parent.get(controlName).errors" aria-live="polite" >
          <i class="icon icon-error" aria-hidden="true"></i>
          <p *ngIf="parent.get(controlName).touched
                      &&
                    parent.get(controlName).hasError('required')"  [id]="controlName +'-error-p'" aria-hidden="false" role="error">{{postCodeConfig['errorMessage']}}</p>
          <p *ngIf="parent.get(controlName).touched
                       &&
                    parent.get(controlName).hasError('notValidPostCode')" [id]="controlName +'-invalid-error'" aria-hidden="false" role="error">
                    {{postCodeConfig['errorMessageInvalid']}}
          </p>
      </div>
   
    
  </div>
  
</div>